import React, { useState } from "react";
import { useMediaQuery } from "@mui/material";
import TextButtonGroup, { ButtonItem } from "./TextButtonGroup";
import { ProductStarRating } from "@/features/product/ProductRating";
import { Button } from "@/components/Button";
import { ImageContentModule } from "@/components/ImageContentModule";
import { theme } from "@/theme";
import { SvgSrcIcon } from "@/components/SvgSrcIcon";
import { CoverImage } from "@/components/CoverImage";
import { useBfState } from "@/helpers/useBfState";
import { setCartAndCheckout } from "@/services/shopifyCart";

export interface FreeTrialFlowProps {
  swap?: boolean;
}

const LemonIcon = () => {
  return (
    <div
      style={{
        backgroundColor: "rgb(255, 232, 146)",
        borderRadius: "50%",
        height: "40px",
        width: "40px",
      }}
    >
      <SvgSrcIcon
        src="https://cdn.shopify.com/s/files/1/0268/4219/files/scent-Lemon-iconfill.svg?v=1605289319"
        height={40}
        width={40}
      />
    </div>
  );
};

const UnscentedIcon = () => {
  return (
    <div
      style={{
        borderRadius: "50%",
        height: "40px",
        width: "40px",
        border: "1px solid rgba(151, 202, 235, 0.3)",
      }}
    >
      <SvgSrcIcon
        src="https://cdn.shopify.com/s/files/1/0268/4219/files/scent-Unscented-iconfill.svg?v=1605289319"
        height={40}
        width={40}
      />
    </div>
  );
};

const buttons: ButtonItem<number>[] = [
  {
    text: "lemon",
    id: 39856434806883,
    Icon: LemonIcon,
  },
  {
    text: "unscented",
    id: 39856433922147,
    Icon: UnscentedIcon,
  },
];

const FreeTrialFlow = ({ swap = false }: FreeTrialFlowProps) => {
  const isMobile: boolean = useMediaQuery(
    theme.breakpoints.down(theme.breakpoints.values.md)
  );

  const left = (
    <div className="h-auto w-auto bg-primary-50 md:h-full">
      <CoverImage src="//cdn.shopify.com/s/files/1/0268/4219/products/dishwasher-lemon.jpg?v=1605581517" />
    </div>
  );
  const right = (
    <div className="h-full bg-primary-50 px-4 py-8 md:px-8 md:py-20 lg:px-20">
      <FreeTrialFlowRight isMobile={isMobile} />
    </div>
  );
  return (
    <ImageContentModule
      className="bg-primary-50"
      image={
        <CoverImage src="//cdn.shopify.com/s/files/1/0268/4219/products/dishwasher-lemon.jpg?v=1605581517" />
      }
      content={<FreeTrialFlowRight isMobile={isMobile} />}
      layout={swap ? "image-right" : "image-left"}
    />
  );
};

const FreeTrialFlowRight = ({ isMobile }: { isMobile: boolean }) => {
  const [buttonId, setButtonId] = useState(39501887864931);
  const [loading, setLoading] = useBfState(false);
  if (!window.getDiscount()) {
    window.applyDiscount("DISHTRIAL");
  }
  const handleClick = () => {
    setLoading(true);
    setCartAndCheckout(
      [
        {
          id: buttonId,
          quantity: 1,
        },
      ],
      "dish_trial"
    );
  };
  return (
    <div className="flex w-full items-center justify-evenly">
      <div className="w-full md:max-w-md md:px-4">
        <p className="subtitle text-xs sm:text-sm">Kitchen</p>
        <h1 className="title">Dishwasher Detergent Trial</h1>
        <p className="body pb-2">9g Ultra-Concentrated Pods</p>
        <ProductStarRating
          color={theme.palette.primary.main}
          starSize="17px"
          reviewScore={4.5}
          label={`${(2500).toLocaleString()}+ 5-Star Reviews`}
        />
        <div className="my-2 border-0 border-b border-solid border-primary-200" />
        <p className="body pb-8 pt-2">
          Helps remove stuck on food and tough greasy residue. No pre-wash
          required. Naturally.
        </p>
        <TextButtonGroup
          buttons={buttons}
          setButtonId={setButtonId}
          selectedButtonId={buttonId}
          style={{ marginBottom: "14px", backgroundColor: "white" }}
        />
        <Button
          className="flex w-full"
          size={isMobile ? "md" : "lg"}
          onClick={handleClick}
          loading={loading}
        >
          GET MY FREE BOX
        </Button>
      </div>
    </div>
  );
};

export default FreeTrialFlow;
